import { DirectiveOptions } from "vue";
import { Vue } from "vue-property-decorator";
import { validateValue } from "@/services/validation/validationService";
import { ValidationType } from "@/services/validation/types";

const validate: DirectiveOptions = {
    bind(element, binding, vNode) {
        const componentContext = vNode.context as any;
        const el = element as HTMLInputElement;

        if (!componentContext || !componentContext.validators) return;

        const property = componentContext.validators[el.id];
        if (!property || !property.rules) return;

        Vue.set(property, "value", binding.value);
        Vue.set(property, "active", true);

        element.addEventListener("input", (event) => {
            Vue.set(property, "value", el.value);

            if (binding.value && binding.value.confirm) {
                const matchRule = (property.rules as any[]).find(x => x.type === ValidationType.Confirm);
                const confirmProperty = componentContext.validators[binding.value.confirm];
                matchRule.value = confirmProperty.value;
            }
            validateValue(property).then(response => {
                Vue.set(property, "message", response.message);
                Vue.set(property, "state", response.state);
            });
        });
    },
    // we use update for setting the value of already populated form fields
    update(element, binding, vNode) {
        const componentContext = vNode.context as any;
        const property = componentContext.validators[element.id];
        Vue.set(property, "value", binding.value);
    },
    unbind(element, binding, vNode) {
        const componentContext = vNode.context as any;
        const property = componentContext.validators[element.id];
        Vue.set(property, "state", null);
        Vue.set(property, "message", "");
        Vue.set(property, "value", "");
        Vue.set(property, "active", false);
    }
};

export default validate;
